import { objectToCamel } from 'ts-case-convert'
import { z } from 'zod'

//* ---------------- BASE ----------------- *//
const baseUploadedImageSchema = z.object({
  id: z.number(),
  type: z.string(),
  reference_id: z.number(),
  url: z.string(),
  description: z.string().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
})

//* ---------------- SCHEMAS --------------- *//
export const uploadedImageSchema = baseUploadedImageSchema.transform(objectToCamel)

//* ---------------- TYPES ---------------- *//
declare global {
  module TrinityAPI {
    type UploadedImageType = z.infer<typeof uploadedImageSchema>
  }
}
